import { render, staticRenderFns } from "./Subscription.vue?vue&type=template&id=6b378b72&scoped=true&"
import script from "./Subscription.vue?vue&type=script&lang=ts&"
export * from "./Subscription.vue?vue&type=script&lang=ts&"
import style0 from "./Subscription.vue?vue&type=style&index=0&id=6b378b72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b378b72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b378b72')) {
      api.createRecord('6b378b72', component.options)
    } else {
      api.reload('6b378b72', component.options)
    }
    module.hot.accept("./Subscription.vue?vue&type=template&id=6b378b72&scoped=true&", function () {
      api.rerender('6b378b72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/Subscription.vue"
export default component.exports